<div class="login-container">
  <mat-card class="login-card">
    @if (!isForgotPasswordView()) {
      <mat-card-header>
        <mat-card-title>Dashboard RMI</mat-card-title>
        <mat-card-subtitle>Accedi alla dashboard</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Email / Username</mat-label>
            <label for="email-input" class="visually-hidden">Email / Username</label>
            <input id="email-input" matInput type="email" formControlName="email" autocomplete="username">
            @if (loginForm.get('email')?.hasError('required') && loginForm.get('email')?.touched) {
              <mat-error>Email is required</mat-error>
            }
            @if (loginForm.get('email')?.hasError('email') && loginForm.get('email')?.touched) {
              <mat-error>Please enter a valid email address</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Password</mat-label>
            <label for="password-input" class="visually-hidden">Password</label>
            <input id="password-input" matInput type="password" [type]="hidePassword() ? 'password' : 'text'" formControlName="password" autocomplete="current-password">
            <button type="button" mat-icon-button matSuffix (click)="hidePassword.set(!hidePassword())" [attr.aria-label]="hidePassword() ? 'Mostra password' : 'Nascondi password'" [attr.aria-pressed]="!hidePassword()" class="password-toggle-btn">
              <mat-icon class="password-toggle-icon">{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched) {
              <mat-error>Password is required</mat-error>
            }
            @if (loginForm.get('password')?.hasError('minlength') && loginForm.get('password')?.touched) {
              <mat-error>Password must be at least 6 characters long</mat-error>
            }
          </mat-form-field>

          <div class="forgot-password-container">
            <button type="button" mat-button class="forgot-password-link" (click)="switchToForgotPassword()">
              Password dimenticata?
            </button>
          </div>

          @if (errorMessage()) {
            <div class="error-banner">
              {{ errorMessage() }}
            </div>
          }

          <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid || isLoading()" class="submit-btn">
            @if (isLoading()) {
              <mat-spinner diameter="20" class="spinner"></mat-spinner>
            } @else {
              Accedi
            }
          </button>
        </form>
      </mat-card-content>
    } @else {
      <mat-card-header>
        <mat-card-title>Ripristino password</mat-card-title>
        <mat-card-subtitle>Inserisci la tua email per ricevere il link di reset</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        @if (resetEmailSent()) {
          <div class="success-container">
            <div class="success-banner">
              Un'email per il ripristino della password è stata inviata all'indirizzo indicato. Controlla la tua casella di posta.
            </div>
            <button mat-raised-button color="primary" type="button" (click)="switchToLogin()" class="submit-btn full-width">
              Torna al login
            </button>
          </div>
        } @else {
          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()" class="login-form">
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>Email</mat-label>
              <label for="reset-email-input" class="visually-hidden">Email</label>
              <input id="reset-email-input" matInput type="email" formControlName="email" autocomplete="username">
              @if (forgotPasswordForm.get('email')?.hasError('required') && forgotPasswordForm.get('email')?.touched) {
                <mat-error>Email is required</mat-error>
              }
              @if (forgotPasswordForm.get('email')?.hasError('email') && forgotPasswordForm.get('email')?.touched) {
                <mat-error>Please enter a valid email address</mat-error>
              }
            </mat-form-field>

            @if (errorMessage()) {
              <div class="error-banner">
                {{ errorMessage() }}
              </div>
            }

            <div class="button-row">
              <button mat-raised-button color="primary" type="submit" [disabled]="forgotPasswordForm.invalid || isLoading()" class="submit-btn half-width">
                @if (isLoading()) {
                  <mat-spinner diameter="20" class="spinner"></mat-spinner>
                } @else {
                  Invia link
                }
              </button>
              <button mat-button type="button" (click)="switchToLogin()" [disabled]="isLoading()" class="cancel-btn half-width">
                Annulla
              </button>
            </div>
          </form>
        }
      </mat-card-content>
    }
  </mat-card>
</div>
